import { render } from "./ConfirmPublishModal.vue?vue&type=template&id=179db951"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"

import "./ConfirmPublishModal.vue?vue&type=style&index=0&id=179db951&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__